import React, { useState, useEffect } from "react";

export default function DarkMode() {
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("theme") != "dark") {
      document.documentElement.classList.add("light");
      localStorage.setItem("theme", "light");
      setIsEnabled(false);
    } else {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
      setIsEnabled(true);
    }
  }, []);

  const handler = () => {
    let htmlClasses = document.querySelector("html").classList;
    if (localStorage.theme == "dark") {
      htmlClasses.remove("dark");
      htmlClasses.add("light");
      localStorage.setItem("theme", "light");
      setIsEnabled(false);
    } else {
      htmlClasses.add("dark");
      htmlClasses.remove("light");
      localStorage.setItem("theme", "dark");
      setIsEnabled(true);
    }
  };

  return (
    <>
      <div
        onClick={handler}
        className="dark-mode-switcher cursor-pointer shadow-md fixed bottom-0 right-0 box dark:bg-dark-2 border rounded-full w-40 h-12 flex items-center justify-center z-50 mb-10 mr-10"
      >
        <div className="mr-4 text-gray-700 dark:text-gray-300">Dark Mode</div>
        <div
          className={`dark-mode-switcher__toggle border transition duration-300 ${
            isEnabled ? "dark-mode-switcher__toggle--active" : ""
          }`}
        ></div>
      </div>
    </>
  );
}
